<div>
  <div class="grid grid-cols-12">
    @if (type === ANALYZER_TYPES.RULE_BASED) {
      <div class="col-span-12">
        <div class="font-bold mb-3">Snort Configuration</div>
        <p-accordion value="0">
          <p-accordion-panel value="0">
            <p-accordion-header>Suppressed Rules</p-accordion-header>
            <p-accordion-content>
              <microsec-card [isNestedCard]="true" [isTableCard]="true">
                <microsec-common-table
                  [cols]="suppressedRuleCols"
                  [values]="displaySuppressedRules"
                  [scrollHeight]="'35rem'"
                  [containerHeaderRightTemplate]="addSuppresedRuleTemplate"
                  [cellTemplate]="cellTemplate"
                  [dataKey]="'id'"
                  itemName="Suppressed Rule"
                  [actionsMenuItems]="customSuppressedActionsItems()" />
              </microsec-card>
            </p-accordion-content>
          </p-accordion-panel>
          <p-accordion-panel value="1">
            <p-accordion-header>IP Whitelist</p-accordion-header>
            <p-accordion-content>
              <microsec-card [isNestedCard]="true" [isTableCard]="true">
                <microsec-common-table
                  [cols]="whitelistCols"
                  [values]="displayWhitelists"
                  [scrollHeight]="'35rem'"
                  [containerHeaderRightTemplate]="addIPWhitelistTemplate"
                  [cellTemplate]="cellTemplate"
                  [dataKey]="'id'"
                  itemName="IP Whitelist Rule"
                  [actionsMenuItems]="customWhitelistActionsItems()" />
              </microsec-card>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </div>
    }

    <div class="col-span-12 mt-5">
      <div class="font-bold mb-3">Rule Types</div>
      <app-ruleset-rule-type #rulesetRuleTypeComponent [ruleTypes]="ruleTypes" />
    </div>
  </div>
</div>

<ng-template #addIPWhitelistTemplate>
  <p-button
    type="button"
    icon="fa fa-plus"
    severity="success"
    size="small"
    pTooltip="Add IP Whitelist"
    tooltipPosition="bottom"
    appendTo="body"
    (onClick)="openForm('whitelist')"
    *ngIf="!!permissions[USER_ROLE.ADMIN]"></p-button>
</ng-template>

<ng-template #addSuppresedRuleTemplate>
  <p-button
    type="button"
    icon="fa fa-plus"
    severity="success"
    size="small"
    pTooltip="Add Suppressed Rules"
    tooltipPosition="bottom"
    appendTo="body"
    (onClick)="openForm('rules_suppressed')"
    *ngIf="!!permissions[USER_ROLE.ADMIN]"></p-button>
</ng-template>

<ng-template let-index="index" let-col="col" let-rowData="rowData" #cellTemplate>
  <ng-container [ngSwitch]="col.field">
    <ng-container *ngSwitchCase="'enabled'">
      <p-toggleSwitch [(ngModel)]="rowData[col.field]" (click)="$event.stopPropagation()"></p-toggleSwitch>
    </ng-container>
    <ng-container *ngSwitchDefault>
      {{ rowData[col.field] || '-' }}
    </ng-container>
  </ng-container>
</ng-template>
